import { Translate } from '.';

export default class SurveyType {
  id: number;
  type: string;
  translates: Translate[];
}
